import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DocModal, { DOCS } from '../../components/DocModal';

// SVG icons inline
const Svg = ({ children, size = 22, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

const ICONS = {
  termos:        (c) => <Svg color={c}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></Svg>,
  privacidade:   (c) => <Svg color={c}><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></Svg>,
  cookies:       (c) => <Svg color={c}><circle cx="12" cy="12" r="10"/><circle cx="8" cy="9" r="1" fill={c}/><circle cx="15" cy="8" r="1" fill={c}/><circle cx="9" cy="15" r="1" fill={c}/><circle cx="15" cy="15" r="1" fill={c}/></Svg>,
  contrato:      (c) => <Svg color={c}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 15l2 2 4-4"/></Svg>,
  kyc:           (c) => <Svg color={c}><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M16 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0"/><path d="M8 10h.01"/><path d="M8 14h8"/></Svg>,
  escrow:        (c) => <Svg color={c}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></Svg>,
  caucao:        (c) => <Svg color={c}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></Svg>,
  cancelamento:  (c) => <Svg color={c}><circle cx="12" cy="12" r="10"/><polyline points="12 8 8 12 12 16"/><line x1="16" y1="12" x2="8" y2="12"/></Svg>,
  danos:         (c) => <Svg color={c}><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></Svg>,
  disputas:      (c) => <Svg color={c}><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></Svg>,
  faq:           (c) => <Svg color={c}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><line x1="9" y1="10" x2="15" y2="10"/><line x1="12" y1="7" x2="12" y2="13"/></Svg>,
  guiaCliente:   (c) => <Svg color={c}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></Svg>,
  guiaFornecedor:(c) => <Svg color={c}><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></Svg>,
};

const GRUPOS = [
  {
    titulo: 'Documentos Legais',
    cor: '#F97316',
    items: [
      { key: 'termos',       desc: 'Condições gerais de uso da plataforma' },
      { key: 'privacidade',  desc: 'Como tratamos os seus dados pessoais' },
      { key: 'cookies',      desc: 'Informação sobre cookies e rastreamento' },
      { key: 'contrato',     desc: 'Acordo vinculativo para utilizadores e fornecedores' },
      { key: 'kyc',          desc: 'Verificação de identidade e prevenção de fraude' },
    ],
  },
  {
    titulo: 'Políticas Financeiras',
    cor: '#2563EB',
    items: [
      { key: 'escrow',       desc: 'Funcionamento do sistema de custódia e pagamentos' },
      { key: 'caucao',       desc: 'Regras de retenção e devolução da caução' },
      { key: 'cancelamento', desc: 'Prazos e condições de cancelamento e reembolso' },
      { key: 'danos',        desc: 'Responsabilidades em caso de dano ou perda' },
    ],
  },
  {
    titulo: 'Disputas & Suporte',
    cor: '#16A34A',
    items: [
      { key: 'disputas',       desc: 'Mecanismos de mediação e resolução de conflitos' },
      { key: 'faq',            desc: 'Respostas às dúvidas mais comuns' },
      { key: 'guiaCliente',    desc: 'Guia completo para clientes da KiAluga' },
      { key: 'guiaFornecedor', desc: 'Manual para maximizar o sucesso como fornecedor' },
    ],
  },
];

export default function Documentos() {
  const navigate = useNavigate();
  const [docAberto, setDocAberto] = useState(null);

  return (
    <div style={{ minHeight: '100vh', background: '#060E1C', fontFamily: 'Plus Jakarta Sans, sans-serif', color: '#fff' }}>
      {/* Header */}
      <div style={{ borderBottom: '1px solid rgba(255,255,255,0.06)', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }} onClick={() => navigate('/')}>
          <div style={{ width: '32px', height: '32px', background: '#F97316', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '800', fontSize: '17px', color: '#fff', fontFamily: 'Syne,sans-serif' }}>K</div>
          <span style={{ fontWeight: '700', fontSize: '15px', fontFamily: 'Syne,sans-serif' }}>KiAluga</span>
        </div>
        <span style={{ color: 'rgba(255,255,255,0.2)', fontSize: '16px' }}>/</span>
        <span style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)' }}>Documentos Legais</span>
      </div>

      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '40px 24px' }}>
        <h1 style={{ fontFamily: 'Syne,sans-serif', fontSize: '28px', fontWeight: '800', marginBottom: '8px' }}>
          Documentos Legais & Políticas
        </h1>
        <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)', marginBottom: '40px', lineHeight: '1.6' }}>
          Todos os documentos que regulam a utilização da plataforma KiAluga. Versão 1.0 — Abril 2026.
          <br />Questões? <a href="mailto:kialuga@gmail.com" style={{ color: '#F97316' }}>kialuga@gmail.com</a>
        </p>

        {GRUPOS.map(g => (
          <div key={g.titulo} style={{ marginBottom: '36px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
              <div style={{ width: '4px', height: '20px', background: g.cor, borderRadius: '2px' }} />
              <h2 style={{ fontSize: '15px', fontWeight: '700', margin: 0 }}>{g.titulo}</h2>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(240px,1fr))', gap: '10px' }}>
              {g.items.map(item => (
                <button key={item.key} onClick={() => setDocAberto(item.key)} style={{
                  background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
                  borderRadius: '12px', padding: '14px 16px', cursor: 'pointer', textAlign: 'left',
                  transition: 'all 0.15s', fontFamily: 'inherit',
                }}
                  onMouseOver={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.07)'; e.currentTarget.style.borderColor = `${g.cor}55`; }}
                  onMouseOut={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; }}
                >
                  <div style={{ marginBottom: '8px', opacity: 0.7 }}>
                    {ICONS[item.key]?.(g.cor)}
                  </div>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: '#fff', marginBottom: '3px' }}>{DOCS[item.key]?.titulo}</div>
                  <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', lineHeight: '1.4' }}>{item.desc}</div>
                  <div style={{ fontSize: '11px', color: g.cor, marginTop: '8px' }}>Ver documento →</div>
                </button>
              ))}
            </div>
          </div>
        ))}

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: '24px', fontSize: '11px', color: 'rgba(255,255,255,0.25)', textAlign: 'center' }}>
          © 2026 KiAluga · ZungaLab, Lda. · Luanda, Angola · kialuga@gmail.com
        </div>
      </div>

      {docAberto && <DocModal docKey={docAberto} onClose={() => setDocAberto(null)} />}
    </div>
  );
}
